import c3 from 'c3';
import 'c3/c3.min.css';
import * as d3 from 'd3';
// import D3Funnel from 'd3-funnel/dist/d3-funnel.js';
import "./styles.css";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import GeoChart from '../GeoChart';
import { pathOr } from "ramda";
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../Skeleton/index";

const CustomDashletMixChart = ({ data, fullData, value='', result = [], showXirrVersion,isDashletUpdated=[],allTabFilter=[],subChartShow = true,isPdf=false, id }) => {
    const { currentTheme } = useSelector((state) => state.config.themeConfig);
    const callbackMethod = pathOr('', ['data', 'callbackMethod'], data);
	let finalChartData = [];
	let maxBar = 0;
	let chartType = [];
	let groupChart = [];
	let chartTitle = '';
	//let YAxisLabel = pathOr(false,['isShowPercent'],data)?'Return':'Amount';
	let YObject = pathOr({},['groupChart'],data)
	let YAxisLabel;
	let Y2AxisLabel;
	let ToggleY2Axis = false;
	const setYAxes = {}
	if(pathOr('', ['groupChart'], data))
	{
		if(pathOr(false,['isShowPercent'],data))
		{
			ToggleY2Axis = true
			YAxisLabel = YObject[0][0].replace("Yearly","")
			Y2AxisLabel = YObject[0][1].replace("Yearly","")
			YObject[0].forEach((obj, index) => {
				setYAxes[obj] = index === 0 ? 'y' : 'y2'
			})
		}
		else
		{
			if(pathOr(false, ['isParentChild']))
			{
				YAxisLabel = YObject[0][0]
				ToggleY2Axis = false
			}
			else
			{
				YAxisLabel = pathOr(false,['isShowPercent'],data)? 'Return' : 'Amount';
				Y2AxisLabel = '';
				ToggleY2Axis = false
			}
		}
				// YAxisLabel = pathOr(false,['isShowPercent'],data)
				// 	? YObject[0][0].replace("Yearly","")
				// 	: pathOr(false, ['isParentChild']) ? YObject[0][0] : 'Amount'
				// console.log("YAxis1", YAxisLabel);
				// Y2AxisLabel = pathOr(false,['isShowPercent'],data)
				// 	? YObject[0][1].replace("Yearly","")
				// 	: pathOr(false, ['isParentChild']) ? YObject[0][1] : 'Amount'
				// console.log("YAxis2", Y2AxisLabel);
				// ToggleY2Axis = true;
	}
	else 
	{
		YAxisLabel = pathOr(false,['isShowPercent'],data) ? 'Return' :' Amount';
		Y2AxisLabel = '';
		ToggleY2Axis = false
	}

	let type= pathOr('', ['type'], data);
	let typeOfChart= pathOr({}, ['typeOfChart'], data);
	let chartActualSize = pathOr({}, ['chartActualSize'], fullData);
	let colorColumns = {};
	var colors = ["#fcd385", "#a0beaf", "#e196aa", "#047281", "#fcd385","#047281","gray","blue","green"];
	Object.keys(typeOfChart).forEach(function(field, index) {
		colorColumns[field] = colors[index];
	});
	if(callbackMethod === 'getSpRp-ITChartData'){
		let callBackResult = getCalculations(callbackMethod, fullData);
		finalChartData = callBackResult.finalChartData;
		maxBar = callBackResult.maxBar;
		chartType = callBackResult.chartType;
		groupChart = callBackResult.groupChart;
		chartTitle = callBackResult.chartTitle;
	
	}else{
		finalChartData = fullData.finalChartData;
		maxBar = fullData.maxBar_5Year;
		type = fullData.chartType;
		chartType = fullData.typeOfChart;
		groupChart = fullData.groupChart;
		chartTitle = fullData.chartTitle;
	
	}

	const [dashId, setDashId] = useState(pathOr('', ['id'], fullData));
	const [showLoading,setShowLoading]= useState(isDashletUpdated.includes(dashId));
	const {  configureDashletLoading } = useSelector(
		(state) => state.dashboard,
	  );
	const makeid=()=> {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	  
		for (var i = 0; i < 5; i++)
		  text += possible.charAt(Math.floor(Math.random() * possible.length));
	  
		return text;
	  }

	const classes = useStyles();
	let chartJson = [];
	const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);
	let chartNewName = Math.random();
	const isConsolidated = pathOr(false, ["isConsolidated"], data)
	let chartName =  isConsolidated ? id : pathOr(pathOr('', ['text'], data), ['name'], data).replace(/\s/g, '_');
	let isShowPercent= pathOr(false,['isShowPercent'],data)?'%':'';

	switch (type) {
		case 'mix_chart':
			//Calculate Ratio of chart
			let ratio = 0.1;
			if(maxBar > 0 && maxBar <=5){
				ratio = isPdf ? 0.6: 0.15;
			}else if(maxBar >=5 && maxBar < 8){
				ratio = 0.3;
			}else if(maxBar >=8 && maxBar < 12){
				ratio = 0.4;
			}else if(maxBar >=12){
				ratio = 0.5;
			}

			chartJson = {
				padding: {
					// right:  20,
					// bottom: 20,
				},
				bindto: '#' + chartName,
				data: {
					x: 'x',
					columns: finalChartData,
					types: chartType,
                    groups: groupChart,
					// colors: colorColumns,
                    // colors: {
                    //     data1: '#698dbf',
                    //     data2: '#859cd1',
                    //     data3: '#cfd5eb',
                    //     data4: '#a4aeca',
                    // },
					empty: { label: { text: "No Data" } },
					axes: setYAxes

				},
    			size:chartActualSize,
				color: {
					pattern: ["#047281", "#e196aa", "#a0beaf", "#fcd385", "#a0beaf","#047281","gray","blue","green"]
				},
				// point: {
				// 	r: 5,
				// },
				// line: {
				// 	thick: 100,
				// },
				title: {
					text: chartTitle,
				},
				// padding: {
				// 	right: 80
				// },				  
				subchart: {
					show: subChartShow
				},
				grid: {
					y: {
						show: true
					}
				},
				bar: {
					width: {
						ratio: ratio // this makes bar width 50% of length between ticks
					}
				}, 
				axis: {
					x: {
						
						extent: [2, 4],
						type: 'category',
						tick: {
							rotate: 30,
							multiline: false,
						},
						// height: 130
					},
					y2: {
						show: ToggleY2Axis,
						tick: {
							format: function (d) {
								var format = d3.format(',');
								return (parseInt(d) == d) ? format(d.toFixed(2))+isShowPercent : format(d.toFixed(2))+isShowPercent;
							}
						},
						label: {
							text: Y2AxisLabel,
							position: 'outer-middle'
						}
					},
					range: { max: 100, min: -100 },
					y: {
						label: {
							text: YAxisLabel,
							position: 'outer-middle'
						},
						tick: {
							format: function (d) {
								var format = d3.format(',');
								return (parseInt(d) == d) ? format(d.toFixed(2))+isShowPercent : format(d.toFixed(2))+isShowPercent;
							}
						}
					}
				},
				tooltip: {
					format: {
						value: function (value, ratio, id) {
							var format = d3.format(',');
							return format(value.toFixed(2));
						}
			//            value: d3.format(',') // apply this format to both y and y2
					}
				}


			};
			break;
		default:
			chartJson = {};

	}

	React.useEffect(() => {
				 c3.generate(chartJson);
		}, [chartJson]);
	return (
		<div className={currentTheme === 'dark' ? "inverted" : null}>

			{
				 (configureDashletLoading && !isDashletUpdated.length) || (showLoading) ? <SkeletonShell layout={data.type==='pie'?"chartRound":"chartRectangle"} /> : <div key={chartName} style={{height:360}} className={classes.chartBox} id={chartName}>
					<Typography align="center"><i className={" fas fa-7x fa-exclamation-triangle " + classes.noData}></i></Typography>
					<Typography align="center" color="textSecondary">No Data</Typography>
				</div>}
		</div>
	);
}
export default (CustomDashletMixChart);